import { render, staticRenderFns } from "./homeProductSlider.vue?vue&type=template&id=f18e753c&scoped=true&"
import script from "./homeProductSlider.vue?vue&type=script&lang=js&"
export * from "./homeProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./homeProductSlider.vue?vue&type=style&index=0&id=f18e753c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18e753c",
  null
  
)

export default component.exports